import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

export const ITEM_DOMAIN_MODEL_FULL_NAME = 'ItemService.ItemObjects.Models.Item';
export const REPLACEMENT_ITEMS_DOMAIN_MODEL_FULL_NAME = 'ItemService.ReplacementItemsObjects.Models.ReplacementItems';
export const SUBJECTS_OF_ITEM_DOMAIN_MODEL_FULL_NAME = 'ItemService.SubjectItemObjects.Models.SubjectsOfItem';
export const BARCODES_OF_ITEM_DOMAIN_MODEL_FULL_NAME = 'ItemService.BarcodeObjects.Models.BarcodesOfItem';
export const KIT_DOMAIN_MODEL_FULL_NAME = 'ItemService.KitObjects.Models.Kit';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                'barcode',
                () => import('./barcode/barcode.module').then(m => m.BarcodeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'brand',
                () => import('./brand/brand.module').then(m => m.BrandModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'family',
                () => import('./family/family.module').then(m => m.FamilyModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'item',
                () => import('./item/item.module').then(m => m.ItemModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'kit',
                () => import('./kit/kit.module').then(m => m.KitModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'logisticgroup',
                () => import('./logistic-group/logistic-group.module').then(m => m.LogisticGroupModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'lot',
                () => import('./lot/lot.module').then(m => m.LotModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'materialclass',
                () => import('./material-class/material-class.module').then(m => m.MaterialClassModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'itemsettings',
                () => import('./item-settings/item-settings.module').then(m => m.ItemSettingsModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'package',
                () => import('./package/package.module').then(m => m.PackageModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'processingphase',
                () => import('./processing-phase/processing-phase.module').then(m => m.ProcessingPhaseModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'productgroup',
                () => import('./product-group/product-group.module').then(m => m.ProductGroupModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'productsubgroup',
                () => import('./product-subgroup/product-subgroup.module').then(m => m.ProductSubgroupModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'replacementitems',
                () => import('./replacement-items/replacement-items.module').then(m => m.ReplacementItemsModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'size',
                () => import('./size/size.module').then(m => m.SizeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'sizelist',
                () => import('./size-list/size-list.module').then(m => m.SizeListModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'subjectitem',
                () => import('./subject-item/subject-item.module').then(m => m.SubjectItemModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'unitofmeasurement',
                () => import('./unit-of-measurement/unit-of-measurement.module').then(m => m.UnitOfMeasurementModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'subjectsofitem',
                () => import('./subjects-of-item/subjects-of-item.module').then(m => m.SubjectsOfItemModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'barcodesofitem',
                () => import('./barcodes-of-item/barcodes-of-item.module').then(m => m.BarcodesOfItemModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
